export default __webpack_public_path__ + "images/H6.a0bb788.png";